import { useEffect } from "react";
import { useRecentStore } from "..";
import { RecentItemType } from "../interfaces/IRecentItem";

export default function useRecentlyViewed(id: number, type: RecentItemType) {
    const recentStore = useRecentStore();

    useEffect(() => {
        recentStore.addRecentItem(id, type);
    }, [id]);
}